import { Divider } from "semantic-ui-react";
import styled from "styled-components";
import { SectionTitle, useFormValue, } from '../common';
import { FieldOptionsComponent } from "./FieldOptions.component";
import React from 'react';
import { FieldFileComponent } from "./FieldFile.component";
import { FieldSchedulingComponent } from "./FieldScheduling.component";
import "../common-form-styles.css";
import { YesNoComponent } from "./YesNoComponent";
import { ValidationActions } from "../ValidationActions";
import { useFluidForm, useFormInstance } from '../FormContext';
import { ErrorBoundary } from "./ErrorBoundary";
import { useFormInstanceSelect } from '../FormInstance.service';
import { FieldInputCompactComponent } from "./FieldInputCompact.component";
const FieldContainer = styled.div.attrs({
    className: 'fluid-field-container'
}) `
  position: relative;
  
  &:hover .help-button {
    opacity: 0.5;
    // transform: translateX(0);
  }
`;
export function FieldComponent(props) {
    return React.createElement(ErrorBoundary, null,
        React.createElement(FieldComponentInner, { ...props }));
}
function FieldComponentInner(props) {
    let component;
    const instanceId = useFormInstance();
    const fieldPath = props.fieldPath;
    const field = useFormInstanceSelect((state) => state.fluidForm.getFieldRenderView(props.fieldPath));
    const config = useFormInstanceSelect((state) => state.fluidForm.getFieldConfigByFieldPath(props.fieldPath));
    let fieldProps = props;
    // Listen for validation changes and pass to children.
    const validationResult = useFormInstanceSelect((state) => state.fluidForm.getFieldValidationResult(fieldPath));
    let [value, _] = useFormValue(fieldPath);
    const validationType = validationResult?.type;
    fieldProps = { validationType: validationType, ...fieldProps };
    if (!config?.type) {
        console.error("Field config type is not defined", config, field);
        return null;
    }
    switch (config.type) {
        case "options":
            component = React.createElement(FieldOptionsComponent, { ...fieldProps });
            break;
        case "multipleOptions":
            component = React.createElement(FieldOptionsComponent, { ...fieldProps });
            break;
        case "section":
            let sectionConfig = config;
            if (config.label) {
                component = React.createElement(SectionTitle, { titleLevel: sectionConfig.sectionLevel }, sectionConfig.label);
            }
            else {
                component = React.createElement(Divider, null);
            }
            break;
        case "yesno":
            component = React.createElement(YesNoComponent, { ...fieldProps });
            break;
        case "file":
            component = React.createElement(FieldFileComponent, { ...fieldProps });
            break;
        case "scheduling":
            component = React.createElement(FieldSchedulingComponent, { ...fieldProps });
            break;
        default:
            component = React.createElement(FieldInputCompactComponent, { ...fieldProps });
            break;
        // default:
        //   component = <FieldTextComponent {...fieldProps} />;
        //   break;
    }
    return (React.createElement(FieldContainer, { "data-field-key": field.key },
        component,
        props.options?.hideInlineValidation !== true &&
            React.createElement(FieldValidation, { field: field, options: props.options })));
}
function FieldValidation({ field, options }) {
    const configService = useFluidForm();
    const instanceId = useFormInstance();
    const validation = useFormInstanceSelect((state) => state.fluidForm.getFieldValidationResult(field.fieldPath));
    if (!validation) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement(ValidationActions, { validation: validation, configService: configService, isEditing: true })));
}
